var map = {
	"./blurred.jpg": 9,
	"./buena-vista.jpg": 24,
	"./github.svg": 25,
	"./heart.svg": 26,
	"./hero-portrait.svg": 27,
	"./indecision-app.jpg": 28,
	"./instagram.svg": 29,
	"./job-listing-and-filtering.png": 30,
	"./link.svg": 31,
	"./linkedin.svg": 32,
	"./logo.svg": 33,
	"./mail-send.png": 11,
	"./myPotrait.jpg": 34,
	"./the-stevenson-hotel.png": 35,
	"./whatsapp.svg": 36
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10;